/**
 * Byte-level access to a learner-display document through our own edge function.
 *
 * Only used where the *contents* are needed (pdf.js). Links the learner clicks
 * ("Open in a new tab") keep pointing at the original file URL.
 */
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL as string | undefined;

/**
 * Returns a same-origin-safe URL whose bytes are identical to `fileUrl`.
 * Falls back to the original URL when no backend is configured (local dev
 * without env) or when the URL is already relative to this app.
 */
export function documentBytesUrl(fileUrl: string): string {
  if (!SUPABASE_URL) return fileUrl;
  if (!/^https:\/\//i.test(fileUrl)) return fileUrl;
  return `${SUPABASE_URL}/functions/v1/document-proxy?url=${encodeURIComponent(fileUrl)}`;
}
